import React from 'react';
import Modal from "react-bootstrap/Modal";
import { Card, CardBody, InputGroup, InputGroupText, InputGroupAddon } from 'reactstrap';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import * as moment from 'moment'

const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
}

export default class Confirmation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showPicker: false
        }

        this.handleSelect = this.handleSelect.bind(this)
        this.openPicker = this.openPicker.bind(this)
        this.closePicker = this.closePicker.bind(this)
    }

    handleSelect(data) {
        console.log(data)
        if (this.props.onSelect) this.props.onSelect(data)
        this.closePicker()
    }

    openPicker() {
        this.setState({ showPicker: true })
    }

    closePicker() {
        this.setState({ showPicker: false })
    }

    render() {
        const { fromDate } = this.props;
        const { showPicker } = this.state;
        return (

            <div className="static-modal">
                <Card className="mb-4 card-custom date-picker-card">
                    <CardBody className="">
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>From Date: {moment(fromDate).format('YYYY-MM-DD')}</InputGroupText>
                            </InputGroupAddon>
                            <InputGroupAddon addonType="append">
                                <button type="submit" className="btn btn-lightblue" onClick={this.openPicker}>Change</button>
                            </InputGroupAddon>
                        </InputGroup>

                        {/*<Row>*/}
                        {/*<Col sm="8" xs="12" className="mb-4  col-lg">*/}
                        {/*<label htmlFor="fromDate">From Date:</label>*/}
                        {/*<input*/}
                        {/*ref="input"*/}
                        {/*type="text"*/}
                        {/*className="form-control"*/}
                        {/*name="fromDate"*/}
                        {/*id="fromDate"*/}
                        {/*value={moment(fromDate).format('YYYY-MM-DD')}*/}
                        {/*/>*/}
                        {/*</Col>*/}
                        {/*<Col sm="4" xs="12" className="mb-4  col-lg">*/}
                        {/*<button type="submit" className="btn btn-purple" onClick={this.openPicker}>Change</button>*/}
                        {/*</Col>*/}
                        {/*</Row>*/}
                    </CardBody>
                </Card>
                <Modal className="modal-light" size="lg" show={showPicker} onHide={this.closePicker}>
                    <Modal.Header>
                    </Modal.Header>
                    <Modal.Body>
                        {showPicker ? <DateRangePicker ranges={[selectionRange]} onChange={this.handleSelect} /> : null}
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/DatePicker.js